import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { 
    RiHome3Line,
    RiClipboardLine,
    RiUserLine,
    RiBriefcaseLine,
    RiWallet3Line,
    RiMessage3Line,
} from 'react-icons/ri'

import routes from '@/routes/routes'
import { projectName } from '@/utils/constants/common'
import useAuthStore from '@/stores/AuthStore'
import { useProfileStatus } from '@/hooks/useProfile'

import './Footer.css'

const Footer = () => {
    const currentYear = new Date().getFullYear()
    const { t } = useTranslation('common')
    const { isLogged } = useAuthStore()
    const { data: profileStatus } = useProfileStatus()
    
    // Generate navigation items matching mobile bottom bar
    const navigationItems = (() => {
        if (!isLogged) {
            return [
                { path: routes.serviceSearch, icon: RiHome3Line, label: 'Servicios' },
                { path: routes.auth, icon: RiUserLine, label: 'Ingresar' },
            ]
        }
        if (profileStatus?.is_provider) {
            return [
                { path: routes.providerRequests, icon: RiClipboardLine, label: 'Solicitudes' },
                { path: routes.providerServices, icon: RiBriefcaseLine, label: 'Mis Servicios' },
                { path: routes.providerWallet, icon: RiWallet3Line, label: 'Billetera' },
                { path: routes.conversations, icon: RiMessage3Line, label: 'Chats' },
                { path: routes.profile, icon: RiUserLine, label: 'Perfil' },
            ]
        }
        return [
            { path: routes.serviceSearch, icon: RiHome3Line, label: 'Servicios' },
            { path: routes.requests, icon: RiClipboardLine, label: 'Mis Pedidos' },
            { path: routes.conversations, icon: RiMessage3Line, label: 'Chats' },
            { path: routes.profile, icon: RiUserLine, label: 'Perfil' },
        ]
    })()
    
    return (
        <footer className="footer-main-cont">
            <div className="footer-container">
                <div className="footer-section footer-branding">
                    <Link to={routes.main} className="footer-logo">
                        <span className="footer-logo-text">{projectName}</span>
                    </Link>
                    <p className="footer-tagline">{t('footer_tagline')}</p>
                </div>

                <div className="footer-section footer-links">
                    <h4>Navegación</h4>
                    <ul>
                        {navigationItems.map((item) => (
                            <li key={item.path}>
                                <Link to={item.path}>
                                    <item.icon className="footer-link-icon" />
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* <div className="footer-section footer-info">
                    <h4>Domber</h4>
                    <p className="footer-description">
                        Plataforma de servicios profesionales a tu alcance.
                    </p>
                </div> */}
            </div>

            <div className="footer-bottom">
                <p className="footer-copyright">
                    {`© ${currentYear} - Domber. Todos los derechos reservados.`}
                </p>
                <p className="footer-made-with">
                    {t('footer_location')}
                </p>
            </div>
        </footer>
    )
}

export default Footer
